import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Col, Form, Row } from "react-bootstrap";
import { withRouter } from "react-router";
import { deletePlantillaCuestionariosOpciones } from "../../../../redux/climalaboral/plantillaCuestionario/action";

const SeleccionUnica = (props) => {
  const [opcionText, setOpcionText] = useState(
    props.valorOpcion ? props.valorOpcion.respuesta : null
  );
  const [opcionValue, setOpcionValue] = useState(
    props.valorOpcion ? props.valorOpcion.valor : null
  );
  const dispatch = useDispatch();

  const addValue = (text, value) => {
    let _opciones = props.opciones;
    setTimeout(() => {
      _opciones[props.index].respuesta = text;
      _opciones[props.index].valor = value;
      props.setOpciones(_opciones);
    }, 2000);
  };

  const onDelete = (id, index) => {
    dispatch(
      deletePlantillaCuestionariosOpciones(
        id,
        index,
        props.setLoader,
        props.opciones,
        props.setOpciones
      )
    );
  };

  return (
    <Form>
      <Row>
        <Form.Group as={Col} className="mb-3 inputHover" md="12">
          <Row className="pl-3 pr-3">
            <Col
              xs="1"
              sm="1"
              md="1"
              lg="1"
              xl="1"
              className="d-flex flex-wrap justify-content-center align-items-center"
            >
              <Row className="flex-wrap justify-content-center align-items-center">
                <span className="a flex-wrap justify-content-center align-items-center buttonGrab">
                  <i
                    className="material-icons dragI"
                    style={{
                      color: "##495057",
                      borderRight: "1px solid #ced4da",
                    }}
                  >
                    drag_indicator
                  </i>
                </span>
                <span className="flex-wrap justify-content-center align-items-center">
                  <i className="material-icons" style={{ color: "##495057" }}>
                    radio_button_unchecked
                  </i>
                </span>
              </Row>
            </Col>
            <Col
              xs="7"
              sm="7"
              md="7"
              lg="7"
              xl="7"
              className="d-flex flex-wrap justify-content-center align-items-center"
            >
              <Form.Control
                id={`opción ${props.indexPregunta}${props.index}`}
                name="opción1"
                className="rounded-pill"
                required
                type="text"
                // onChange={onSubmit}
                // defaultValue={
                //   props.valorOpcion ? props.valorOpcion.respuesta : null
                // }
                value={opcionText}
                onChange={(e) => {
                  // e.preventDefault();
                  // setTimeout(() => {
                  setOpcionText(e.currentTarget.value);
                  addValue(e.currentTarget.value, opcionValue);
                  // }, 1000);
                }}
                pattern="^[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9@$¿?¡\-_%#]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9@$¿?¡\-_%#]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9@$¿?¡\-_%#]+$"
                // pattern="^[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]+$"
                placeholder="Opción 1"
              ></Form.Control>
            </Col>
            <Col
              xs="2"
              sm="2"
              md="2"
              lg="2"
              xl="2"
              className="d-flex flex-wrap justify-content-center align-items-center"
            >
              <Form.Control
                id={`Valor ${props.indexPregunta}${props.index}`}
                name="Valor"
                className="rounded-pill"
                required
                type="number"
                min="0.00"
                // onChange={onSubmitValue}
                // defaultValue={
                //   props.valorOpcion ? props.valorOpcion.valor : null
                // }
                value={opcionValue}
                onChange={(e) => {
                  // e.preventDefault();
                  // setTimeout(() => {
                  setOpcionValue(e.currentTarget.value);
                  addValue(opcionText, e.currentTarget.value);
                  // }, 1000);
                }}
                pattern="/^[+-]?([0-9]+\.?[0-9]*|\.[0-9]+)$/"
                placeholder="Valor"
              ></Form.Control>
            </Col>
            <Col
              xs="1"
              sm="1"
              md="1"
              lg="1"
              xl="1"
              className="c d-flex flex-wrap justify-content-center align-items-center"
            >
              <Button
                variant="link"
                size="sm"
                className="text-dark rounded-pill"
                // disabled={props.length===1?true:false}
                style={{ display: props.length === 1 ? "none" : "block" }}
                onClick={() => onDelete(props.valorOpcion.id, props.index)}
                disabled={props.loader}
              >
                <i className="material-icons">close</i>
              </Button>
            </Col>
          </Row>
        </Form.Group>
      </Row>
    </Form>
  );
};

export default withRouter(SeleccionUnica);
